module.exports = __webpack_public_path__ + "media/bug.08e3267e.mp3";